import React, { useRef, useState } from 'react';
import StyledQuill from '../shared/StyledQuill';
import { uploadFileToFirebase } from '../../utils/firebaseUploadUtils';
import { addActivity } from '../../utils/cardUtils';
import {
    Section,
    SectionTitle,
    QuillEditorContainer
} from '../../styles/CardModal.styles';

const CardDescription = ({ cardData, setCardData, saveCardChanges, onAddAttachment, user }) => {
    const quillRef = useRef(null);
    const [descriptionOnFocus, setDescriptionOnFocus] = useState(cardData.description || '');

    const handleImageUpload = async (file) => {
        try {
            const attachment = await uploadFileToFirebase(file, 'editor-images');
            if (attachment) {
                const editor = quillRef.current.getEditor();
                const range = editor.getSelection();
                editor.insertEmbed(range.index, 'image', attachment.url);
                onAddAttachment(attachment); // Add to attachments array
            }
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    const handlePaste = (e) => {
        const clipboard = e.clipboardData;
        if (clipboard.files.length > 0) {
            e.preventDefault();
            Array.from(clipboard.files).forEach(file => {
                if (file.type.startsWith('image/')) {
                    handleImageUpload(file);
                } else {
                    // Handle non-image files as links
                    uploadFileToFirebase(file, 'editor-files').then(attachment => {
                        if (attachment) {
                            const editor = quillRef.current.getEditor();
                            const range = editor.getSelection();
                            editor.insertText(range.index, attachment.name, { 'link': attachment.url });
                            onAddAttachment(attachment); // Add to attachments array
                        }
                    });
                }
            });
        }
    };

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image']
        ],
        clipboard: {
            matchVisual: false,
        },
    };

    const formats = [
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link', 'image'
    ];

    return (
        <Section>
            <SectionTitle>Description</SectionTitle>
            <QuillEditorContainer>
                <StyledQuill
                    ref={quillRef}
                    theme="snow"
                    value={cardData.description || ''}
                    onChange={(content, delta, source, editor) => {
                        setCardData(prev => ({
                            ...prev,
                            description: content
                        }));
                    }}
                    onFocus={() => {
                        setDescriptionOnFocus(cardData.description || '');
                    }}
                    onBlur={() => {
                        const currentDescription = cardData.description || '';
                        const focusedDescription = descriptionOnFocus || '';
                        if (focusedDescription !== currentDescription) {
                            const activity = addActivity(user, {
                                type: 'description',
                                from: focusedDescription,
                                to: currentDescription,
                            });
                            saveCardChanges(
                                { description: cardData.description }, // Send actual value
                                activity
                            );
                        }
                    }}
                    modules={modules}
                    formats={formats}
                    onPaste={handlePaste}
                    placeholder="Add a detailed description..."
                />
            </QuillEditorContainer>
        </Section>
    );
};

export default CardDescription;